import http from "@/utils/request"

export default {
  getReviewTotal: function (inputForm) {
    return http.get('/erp/audit/currentAuditNode/countNowData',inputForm)
  },
  countPurchaseOrderYM: function (inputForm) {
    return http.get('/erp/home/counts/countPurchaseOrderYM',inputForm)
  },
  countMoneyPurchaseYM: function (inputForm) {
    return http.get('/erp/home/counts/countMoneyPurchaseYM',inputForm)
  },
  countSaleOrderYM: function (inputForm) {
    return http.get('/erp/home/counts/countSaleOrderYM',inputForm)
  },
  countMoneySaleYM: function (inputForm) {
    return http.get('/erp/home/counts/countMoneySaleYM',inputForm)
  },
  hotGoodsYM: function (inputForm) {
    return http.get('/erp/home/counts/hotGoodsYM',inputForm)
  },
  hotCustomerByYM: function (inputForm) {
    return http.get('/erp/home/counts/hotCustomerByYM',inputForm)
  },
  countDataByMD: function (inputForm) {
    return http.get('/erp/home/counts/countDataByMD',inputForm)
  },
  codeLogin: function (inputForm) {
    return http.get('/auth/usercenter/codeLogin',inputForm)
  },
  
}
